import { reduce } from 'lodash';
import { VALIDATION_ERROR } from '../constants';
import { getErrorByStatusCode } from '../helpers';

const formatFieldErrors = (fieldErrors) => reduce(fieldErrors, (fields, { name, message }) => (
  { ...fields, [name]: message }
), {});

const parseValidationError = (fieldErrors) => {
  const combinedFieldErrors = fieldErrors.map(err => err.extensions.fields).flat();

  return {
    type: VALIDATION_ERROR,
    fields: formatFieldErrors(combinedFieldErrors),
    message: null
  };
};

const validationErrorParser = error => {
  const fieldErrors = getErrorByStatusCode(error, VALIDATION_ERROR);

  return {
    hasErrors: () => !!fieldErrors,
    parse: () => parseValidationError(fieldErrors)
  };
};

export default validationErrorParser;
